import Vue from 'vue';
import {STATES} from '../misc/StoreStates';
import store from './store';
import md5 from 'md5';

const doesMutationExist = (mutation) => Object.keys(store._mutations).indexOf(mutation) !== -1;
const commitIfExist = (commit, mutation, value) => {
	if (doesMutationExist(mutation)) {
		commit(mutation, value);
	}
};

const states = {};

const getSomethingFromApiAndStoreInStore = async (commit, url, NAMESPACE) => {
	const SET_KEY = `SET_${NAMESPACE}`;
	const STATE_KEY = NAMESPACE;
	const urlId = md5(url);

	if (!states.hasOwnProperty(STATE_KEY) || states[STATE_KEY].id !== urlId) {
		states[STATE_KEY] = {
			id: urlId,
			state: STATES.IDLE,
			promise: null
		};
		commitIfExist(commit, SET_KEY, []);
	}

	if ([STATES.LOADING, STATES.LOADED, STATES.FAILED].indexOf(states[STATE_KEY].state) !== -1) {
		return states[STATE_KEY].promise;
	}

	states[STATE_KEY].state = STATES.LOADING;
	states[STATE_KEY].promise = createActionPromise(commit, url, SET_KEY, STATE_KEY);
	return states[STATE_KEY].promise;
};

const createActionPromise = async (commit, url, SET_KEY, STATE_KEY) => {
	try {
		const results = await getSomethingFromApi(url);
		states[STATE_KEY].state = STATES.LOADED;
		commitIfExist(commit, SET_KEY, results);
	} catch (error) {
		states[STATE_KEY].state = STATES.FAILED;
		const errorMessage = `ReviewsStore: Could not load ${STATE_KEY} data.`;
		if (error.status !== 404) {
			console.error(errorMessage, error);
		}
		throw new Error(errorMessage);
	}
};

const getSomethingFromApi = async (url) => {
	const response = await Vue.http.get(url);
	return response.json();
};

export const loadUniversities = ({commit}) => {
	return getSomethingFromApiAndStoreInStore(commit, `v1/universities`, 'UNIVERSITIES');
};
